import { render, staticRenderFns } from "./TriesOverview.vue?vue&type=template&id=f05fd288&scoped=true"
import script from "./TriesOverview.vue?vue&type=script&lang=js"
export * from "./TriesOverview.vue?vue&type=script&lang=js"
import style0 from "./TriesOverview.vue?vue&type=style&index=0&id=f05fd288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.2_webpack@5.104.1__lodash@4.17.23_react-dom@16.14.0_r_74e494c6076ab34d677e70338ea024d9/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05fd288",
  null
  
)

export default component.exports